import React from 'react'

const Home = () => {
  const year = 2026
  const month = 8

  const monthLabel = new Intl.DateTimeFormat('pt-BR', {
    month: 'long',
    year: 'numeric',
  }).format(new Date(year, month, 1)).replace(' de ', ' ')

  const weekdays = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']

  const firstDayOfMonth = new Date(year, month, 1)
  const lastDayOfMonth = new Date(year, month + 1, 0)
  const firstWeekday = (firstDayOfMonth.getDay() + 6) % 7
  const daysInMonth = lastDayOfMonth.getDate()

  const holidayMap = {
    1: 'Marcado',
    7: 'Marcado',
    15: 'Marcado',
    20: 'Marcado',
    22: 'Marcado',
  }

  const days = []

  for (let i = 0; i < firstWeekday; i += 1) {
    days.push(null)
  }

  for (let day = 1; day <= daysInMonth; day += 1) {
    days.push(day)
  }

  while (days.length % 7 !== 0) {
    days.push(null)
  }

  return (
    <div>
      <main className="mainContent">
        <section className="heroSection">
          <div className="heroText">
            <span>Institucional</span>
            <h1>Conheça a ASJF</h1>
            <p>
              Nossa associação promove inclusão, cultura e cidadania para a comunidade surda de Juiz de Fora.
            </p>
          </div>
          <div className="heroCard">
            <h2>Destaque</h2>
            <p>Veja informações importantes e documentos recentes sobre a nossa atuação.</p>
          </div>
        </section>

        <section className="cardGrid">
          <article className="infoCard">
            <h3>Missão</h3>
            <p>Promover a participação social e os direitos das pessoas surdas na região.</p>
          </article>
          <article className="infoCard">
            <h3>Visão</h3>
            <p>Ser referência em inclusão e acessibilidade para a comunidade surda.</p>
          </article>
          <article className="infoCard">
            <h3>Valores</h3>
            <p>Respeito, transparência, colaboração e fortalecimento da diversidade.</p>
          </article>
        </section>

        <section className="mapSection">
          <div className="mapText">
            <span>Calendário</span>
            <h2>{monthLabel}</h2>
            <div className="calendarCard">
              <div className="calendarHeader">
                {weekdays.map((day) => (
                  <span key={day}>{day}</span>
                ))}
              </div>
              <div className="calendarGrid">
                {days.map((day, index) => {
                  if (day === null) {
                    return <span key={`empty-${index}`} className="calendarEmpty" aria-hidden="true" />
                  }

                  const isToday = day === 1
                  const isMarked = holidayMap[day]

                  return (
                    <span
                      key={`day-${day}`}
                      className={`${isMarked ? 'calendarMarked' : ''} ${isToday ? 'calendarHighlight' : ''}`.trim()}
                      title={isMarked || undefined}
                    >
                      {day}
                    </span>
                  )
                })}
              </div>
            </div>
          </div>
          <div className="mapCard">
            <div className="mapGrid">
              <iframe
                className="mapFrame"
                src="https://www.google.com/maps?q=Rua+Mister+Moore+157+Juiz+de+Fora+MG&output=embed"
                title="Mapa da sede ASJF"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="mapInfo">
              <strong>ASJF</strong>
              <p>Rua Mister Moore, nº 157, sala 105</p>
              <p>Centro - Juiz de Fora - MG</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  )
}

export default Home